/*  ========================================================================
    # Tailwind CSS
    ========================================================================  */

module.exports = {
  content: [
    './theme/functions/**/*.php',
    './theme/classes/**/*.php',
    './src/react/**/*.{js,jsx,ts,tsx}'
  ],
  prefix: 'tw-',
  corePlugins: {
    preflight: false,
    container: false
  },
  plugins: [],
  theme: {
    screens: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
      xxl: '1440px'
    }
  }
};
